<h2>Onze alpaca's</h2>
<app-http-loader [componentId]="componentId">
    @for(alpacaCat of (groupedAlpacas | keyvalue); track alpacaCat) {
        <h3>{{ alpacaCat.key }}</h3>
        <ul>
            @for(alpaca of alpacaCat.value; track alpaca) {
            <div class="sidebar-alpaca-link">
                <li>
                    <a [routerLink]="['/alpacas/detail/', alpaca.id]">{{alpaca.shortName}}
                    @if(alpaca.status === 'Te koop') { <span>(Te koop)</span> }
                    </a>
                </li>
            </div>
            }
        </ul>
    }
</app-http-loader>